export const config = {
  'api-key': 'AIzaSyAWfBp_l7JJoLYj0AOlHNThBvFbY4ickTg',
};